export class EstruturaRetornoOutputDto {
  erros: string[];

  constructor(erros: string[]) {
      this.erros = erros;
  }
}
